export const PNG_IMAGES = {
    hand: require('../../../images/hand.png'),
    summarizationWelcome: require('../../../images/promo/summarization-welcome.png'),
    blurredV2: require('../../../images/background/blurred-v2.png'),
} as const;

export type PngImageName = keyof typeof PNG_IMAGES;
